import "./ProfileNotificationSettings.html";

import "./EditForm/ProfileNotificationSettingsEditComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import ProfileNotificationSettingsComponentController from "./ProfileNotificationSettingsComponentController";

export default class ProfileNotificationSettingsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            profile: "<",
        };
        this.controller = ProfileNotificationSettingsComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/NotificationSettings/ProfileNotificationSettings.html";
    }
}

module("mmAuth").component("mmProfileNotificationSettings", new ProfileNotificationSettingsComponent());
